import { Button, UIHeading4, Textarea, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { IUpdateNoteParams } from '../../../actions/favoriteEntities/notes';
import { EDeviceType } from '../../../types/device';

export interface ICommentFormProps {
  entityId: number;
  isFetching?: boolean;
  comment?: string | null;
  onSubmitComment(params: IUpdateNoteParams): void;
  onCancelComment(): void;
}

export interface ICommentFormState {
  comment: string;
}

export const CommentForm = ({ comment, isFetching, onCancelComment, onSubmitComment, entityId }: ICommentFormProps) => {
  const [nextComment, setNextComment] = React.useState(comment || '');

  const device = useDeviceType();
  const size = device === EDeviceType.Desktop ? 'XS' : 'M';

  const isDisableSend = nextComment.trim().length === 0 && !comment;

  // oxlint-disable-next-line typescript/no-explicit-any
  const handleChange = React.useCallback((_event: any, value: string) => {
    setNextComment(value);
  }, []);

  const handleCancel = React.useCallback(() => {
    onCancelComment();
  }, [onCancelComment]);

  const handleSubmit = React.useCallback(() => {
    onSubmitComment({ comment: nextComment, entityId });
  }, [entityId, nextComment, onSubmitComment]);

  return (
    <div className={styles['container']}>
      <div>
        <UIHeading4>Ваша заметка:</UIHeading4>
      </div>
      <Textarea
        autoFocus
        size={size}
        value={nextComment}
        onChange={handleChange}
        disabled={isFetching}
        placeholder="Оставьте комментарий для объекта"
        minRows={3}
      />
      <div className={styles['buttons']}>
        <Button size={size} disabled={isFetching} onClick={handleCancel} theme="fill_secondary">
          Отменить
        </Button>
        <Button size={size} loading={isFetching} disabled={isFetching || isDisableSend} onClick={handleSubmit}>
          {!comment ? 'Сохранить' : 'Отправить'}
        </Button>
      </div>
    </div>
  );
};
